import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "numberThousand"
})
export class NumberThousandPipe implements PipeTransform {

    transform(value: number): any {
        return String(value).replace(
            /(?!^)(?=(?:\d{3})+$)/g,
            ' '
        );
    }

}
